import { Injectable } from '@angular/core';

import { PieChartData } from '../models/pie-chart-data.model';
import { pieChartOptions } from '../options/pie-chart.options';
import { pieChartMoneyOptions } from '../options/pie-chart-money.options';

import * as Chart from 'chart.js';
import * as numeral from 'numeral';
import 'numeral/locales/pt-br';
import 'chartjs-plugin-datalabels';

@Injectable()
export class PieChartService {

  constructor() { }

  generatePieChart(chartCanvas: any, pieChartData: PieChartData, chartTypeOptions = 'default', displayLegend: boolean = true, legendPosition: string = 'top') {
    const pieChartBaseOptions: any = chartTypeOptions === 'default' ? pieChartOptions : pieChartMoneyOptions;

    // Check if the legend will be displayed.
    pieChartBaseOptions.legend.display = displayLegend;

    // Defines legend position.
    pieChartBaseOptions.legend.position = legendPosition;

    this.generateChart(chartCanvas, pieChartData, pieChartBaseOptions);
  }

  generateDoughnutChart(chartCanvas: any, pieChartData: PieChartData, displayLegend: boolean = true, legendPosition: string = 'top') {
    const pieChartBaseOptions: any = pieChartOptions;

    // Check if the legend will be displayed.
    pieChartBaseOptions.legend.display = displayLegend;

    // Defines legend position.
    pieChartBaseOptions.legend.position = legendPosition;

    this.generateChart(chartCanvas, pieChartData, pieChartBaseOptions, 'doughnut');
  }

  private generateChart(chartCanvas: any, pieChartData: PieChartData, chartOptions: any, chartType: string = 'pie') {
    const chart = new Chart(chartCanvas, {
      // The type of chart we want to create.
      type: chartType,

      // The data for our dataset
      data: {
        labels: pieChartData.labels,
        datasets: [{
          data: pieChartData.data,
          backgroundColor: pieChartData.backgroundColors
        }]
      },

      // Configuration options go here
      options: chartOptions
    });
  }
}
